import React, { useRef, useState } from 'react'
import "./banner.scss"

const OTP_LENGTH = 6
const API_BASE = process.env.REACT_APP_API_URL || ''

const maskEmail = (value) => {
    const [name = '', domain = ''] = value.split('@')
    if (!domain) return value
    return `${name.slice(0, 2)}•••@${domain}`
}

const Banner = () => {
    const [step, setStep] = useState(null)
    const [email, setEmail] = useState('')
    const [code, setCode] = useState(Array(OTP_LENGTH).fill(''))
    const [copied, setCopied] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [memberId, setMemberId] = useState('')
    const [position, setPosition] = useState(null)
    const otpRefs = useRef([])

    const shareUrl = typeof window !== 'undefined' ? window.location.origin : 'https://veyro.com'
    const displayPosition = position || '—'
    const shareText = `I'm #${displayPosition} on the Veyro waitlist. Crypto without limits.`

    const closeModal = () => {
        setStep(null)
        setCode(Array(OTP_LENGTH).fill(''))
        setCopied(false)
        setError('')
        setLoading(false)
    }

    const sendOtp = async () => {
        const trimmed = email.trim()
        if (!trimmed) return

        setLoading(true)
        setError('')
        try {
            const response = await fetch(`${API_BASE}/api/otp/send`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: trimmed }),
            })
            const data = await response.json().catch(() => ({}))
            if (!response.ok) {
                throw new Error(data.error || 'Failed to send verification code.')
            }

            setCode(Array(OTP_LENGTH).fill(''))
            setStep('otp')
            setTimeout(() => otpRefs.current[0] && otpRefs.current[0].focus(), 0)
        } catch (err) {
            setError(err.message || 'Failed to send verification code.')
        } finally {
            setLoading(false)
        }
    }

    const handleOtpChange = (index, value) => {
        const digit = value.replace(/\D/g, '').slice(-1)
        const next = [...code]
        next[index] = digit
        setCode(next)
        setError('')
        if (digit && index < OTP_LENGTH - 1) otpRefs.current[index + 1].focus()
    }

    const handleOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !code[index] && index > 0) {
            otpRefs.current[index - 1].focus()
        }
        if (e.key === 'ArrowLeft' && index > 0) otpRefs.current[index - 1].focus()
        if (e.key === 'ArrowRight' && index < OTP_LENGTH - 1) otpRefs.current[index + 1].focus()
    }

    const handleOtpPaste = (e) => {
        e.preventDefault()
        const digits = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, OTP_LENGTH).split('')
        if (!digits.length) return
        const next = Array(OTP_LENGTH).fill('')
        digits.forEach((d, i) => { next[i] = d })
        setCode(next)
        setError('')
        const focusIndex = Math.min(digits.length, OTP_LENGTH - 1)
        otpRefs.current[focusIndex].focus()
    }

    const otpFilled = code.every((d) => d !== '')

    const handleConfirm = async () => {
        if (!otpFilled || loading) return

        setLoading(true)
        setError('')
        try {
            const response = await fetch(`${API_BASE}/api/otp/verify`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: email.trim(),
                    code: code.join(''),
                }),
            })
            const data = await response.json().catch(() => ({}))
            if (!response.ok) {
                throw new Error(data.error || 'Failed to verify code.')
            }

            setMemberId(data.memberId || '')
            setPosition(data.position || null)
            setStep('success')
        } catch (err) {
            setError(err.message || 'Failed to verify code.')
        } finally {
            setLoading(false)
        }
    }

    const handleCopyLink = () => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(shareUrl)
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        }
    }

    return (
        <>
            <section className='main_bannnner'>
                <img src="\assets\bannerbg.png" alt="" className='imgback deskbg' />
                <img src="\assets\phonebg.png" alt="" className='imgback phonebg' />
                <div className='custom-container'>
                    <div className='innerbanner'>
                        <div className='leftside'>
                            <h2>CRYPTO</h2>
                            <h3>WITHOUT <span>LIMITS</span> </h3>
                            <p>Your keys. Your money. Spendable anywhere Visa works</p>
                            <div className='inputtypeside'>
                                <input
                                    type="email"
                                    placeholder='Enter your email'
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                        setError('')
                                    }}
                                    onKeyDown={(e) => e.key === 'Enter' && !loading && sendOtp()}
                                    disabled={loading}
                                />
                                <button onClick={sendOtp} disabled={loading || !email.trim()}>
                                    {loading && step !== 'otp' ? 'Sending…' : 'Join Waitlist'}
                                </button>
                            </div>
                            {error && !step && <p className='waitlist_inline_error'>{error}</p>}
                        </div>
                        <div className='imgright'>
                            <img src="\assets\veyrocard.svg" alt="" className='deskimg' />
                            <img src="\assets\phone.png" alt="" className='phoneimg' />
                        </div>
                    </div>
                    <div className='threexaeds'>
                        <div className='cards'>
                            <img src="\assets\cardsbg.png" alt="" className='bggg' />
                            <img src="\assets\one.svg" alt="" />
                            <h3>Hold</h3>
                            <h4>Securely store your crypto assets with full control.</h4>
                        </div>
                        {/* <div className='cards'>
                            <img src="\assets\cardsbg.png" alt="" className='bggg' />
                            <img src="\assets\two.svg" alt="" />
                            <h3>Grow</h3>
                            <h4>Earn high yields on your holdings instantly</h4>
                        </div> */}
                        <div className='cards'>
                            <img src="\assets\cardsbg.png" alt="" className='bggg' />
                            <img src="\assets\three.svg" alt="" />
                            <h3>Spend</h3>
                            <h4>Free virtual card, spend globally.</h4>
                        </div>
                    </div>
                </div>
            </section>

            {step && (
                <div className='waitlist_modal_overlay' onClick={closeModal}>
                    <div className='waitlist_modal' onClick={(e) => e.stopPropagation()}>
                        <button className='closebtn' onClick={closeModal} aria-label='Close'>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6L18 18" stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>

                        {step === 'otp' && (
                            <>
                                <div className='ouuuter'>
                                    <img src="\assets\tick.svg" alt="" />
                                    <h3>You're on the <span>list.</span></h3>
                                    <p>Enter the 6-digit code we sent to {maskEmail(email)}</p>

                                    <div className='otpboxes' onPaste={handleOtpPaste}>
                                        {code.map((digit, index) => (
                                            <input
                                                key={index}
                                                ref={(el) => { otpRefs.current[index] = el }}
                                                type="text"
                                                inputMode='numeric'
                                                autoComplete='one-time-code'
                                                maxLength={1}
                                                value={digit}
                                                onChange={(e) => handleOtpChange(index, e.target.value)}
                                                onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                                aria-label={`Digit ${index + 1}`}
                                                disabled={loading}
                                            />
                                        ))}
                                    </div>

                                    {error && <p className='waitlist_inline_error'>{error}</p>}

                                    <button
                                        type='button'
                                        className='resendcode'
                                        onClick={sendOtp}
                                        disabled={loading}
                                    >
                                        {loading ? 'Sending…' : 'Resend Code'}
                                    </button>
                                </div>

                                <div className='butttton'>
                                    <button
                                        className='gotitbtn'
                                        onClick={handleConfirm}
                                        disabled={!otpFilled || loading}
                                    >
                                        {loading ? 'Verifying…' : 'Confirm'}
                                    </button>
                                </div>
                            </>
                        )}

                        {step === 'success' && (
                            <>
                                <div className='ouuuter'>
                                    <img src="\assets\vlogo.svg" alt="Veyro" className='vlogoimg' />
                                    <h3>Welcome to <span>Veyro.</span></h3>
                                    <p>You're <b>#{displayPosition}</b> in line. We'll be in touch before launch — keep an eye on your inbox.</p>

                                    <div className='founderbadge'>
                                        <span className='labell'>FOUNDER</span>
                                        <span className='valuee'>{memberId || `Veyro #${displayPosition}`}</span>
                                    </div>

                                    <div className='shareside'>
                                        <h4>Share with friends</h4>
                                        <div className='sharelinks'>
                                            <a
                                                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                                                target='_blank'
                                                rel='noreferrer'
                                            >
                                                <span className='iconbox'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <g clipPath="url(#clip0_766_171781)">
                                                            <path d="M10.3936 18V9.78996H13.1482L13.5615 6.58941H10.3936V4.54632C10.3936 3.61998 10.6498 2.98869 11.9796 2.98869L13.673 2.98799V0.125307C13.3802 0.0872508 12.3749 0 11.2049 0C8.76181 0 7.08919 1.49127 7.08919 4.22934V6.58941H4.32617V9.78996H7.08919V18H10.3936Z" fill="white" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_766_171781">
                                                                <rect width="18" height="18" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </span>
                                                Facebook
                                            </a>

                                            <a
                                                href={`https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`}
                                                target='_blank'
                                                rel='noreferrer'
                                            >
                                                <span className='iconbox'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path d="M12.4312 7.06158C12.8912 6.58786 13.3479 5.4825 11.4311 6.82472C9.64055 8.09375 7.83781 9.34449 6.02317 10.5768C5.74685 10.7054 5.44812 10.7753 5.14493 10.7821C4.84174 10.7888 4.54035 10.7325 4.25886 10.6163C3.10877 10.261 1.76615 9.78724 1.76615 9.78724C1.76615 9.78724 0.849412 9.19422 2.41871 8.56259C2.41871 8.56259 9.05341 5.75884 11.3544 4.77105C12.2362 4.37628 15.2273 3.11301 15.2273 3.11301C15.2273 3.11301 16.6082 2.55947 16.4932 3.90255C16.4549 4.45523 16.1482 6.39133 15.8415 8.48363C15.3806 11.4453 14.8822 14.6841 14.8822 14.6841C14.8822 14.6841 14.8056 15.5921 14.1538 15.75C13.4562 15.7378 12.7821 15.4879 12.237 15.0394C12.0837 14.921 9.36094 13.1437 8.36336 12.2752C8.26185 12.2044 8.17942 12.1083 8.12367 11.9959C8.068 11.8835 8.04075 11.7583 8.04458 11.6322C8.04841 11.506 8.08317 11.383 8.14559 11.2743C8.20801 11.1658 8.2961 11.0751 8.40169 11.011C9.76997 9.72193 11.1133 8.40519 12.4312 7.06158Z" fill="white" />
                                                    </svg>
                                                </span>
                                                Telegram
                                            </a>

                                            <a
                                                href={`https://wa.me/?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`}
                                                target='_blank'
                                                rel='noreferrer'
                                            >
                                                <span className='iconbox'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path d="M8.9988 0.71875C4.43328 0.71875 0.718803 4.43323 0.718803 8.99875C0.718803 10.4243 1.08708 11.8262 1.78548 13.0631L0.732123 16.8215C0.697563 16.945 0.731043 17.0775 0.820323 17.1693C0.889083 17.2402 0.982683 17.2787 1.0788 17.2787C1.1076 17.2787 1.13676 17.2752 1.1652 17.2683L5.08776 16.2967C6.28548 16.9396 7.6344 17.2787 8.9988 17.2787C13.5643 17.2787 17.2788 13.5643 17.2788 8.99875C17.2788 4.43323 13.5643 0.71875 8.9988 0.71875ZM13.164 11.9205C12.9869 12.4108 12.1373 12.8583 11.729 12.9184C11.3626 12.9721 10.8989 12.9951 10.3898 12.8353C10.0813 12.7381 9.68532 12.6092 9.17808 12.3928C7.0458 11.4835 5.65332 9.36343 5.54676 9.22339C5.44056 9.08335 4.6788 8.08543 4.6788 7.05259C4.6788 6.01975 5.2278 5.51179 5.42292 5.30155C5.61804 5.09131 5.84808 5.03875 5.98992 5.03875C6.13176 5.03875 6.27324 5.04055 6.39744 5.04631C6.52812 5.05279 6.70344 4.99699 6.87588 5.40667C7.053 5.82715 7.47816 6.85999 7.53072 6.96547C7.584 7.07059 7.61928 7.19335 7.54872 7.33339C7.47816 7.47343 7.44288 7.56091 7.33632 7.68367C7.22976 7.80643 7.11312 7.95727 7.01736 8.05159C6.9108 8.15635 6.80028 8.26975 6.92412 8.47999C7.04796 8.69023 7.47456 9.37747 8.10672 9.93403C8.91852 10.649 9.6036 10.8707 9.816 10.9759C10.0284 11.081 10.1526 11.0633 10.2764 10.9233C10.4003 10.7829 10.8078 10.3102 10.9493 10.1003C11.0908 9.89047 11.2326 9.92503 11.4277 9.99523C11.6228 10.0651 12.6679 10.5727 12.8803 10.6778C13.0927 10.7829 13.2346 10.8355 13.2878 10.9229C13.3411 11.0101 13.3411 11.4305 13.164 11.9205Z" fill="white" />
                                                    </svg>
                                                </span>
                                                Whatsapp
                                            </a>

                                            <a href={`mailto:?subject=${encodeURIComponent('Join me on the Veyro waitlist')}&body=${encodeURIComponent(`${shareText} ${shareUrl}`)}`}>
                                                <span className='iconbox'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path d="M10.5043 11.0278C10.0565 11.3264 9.53631 11.4842 9 11.4842C8.46373 11.4842 7.94355 11.3264 7.49573 11.0278L0.119848 6.1104C0.0789258 6.08312 0.0390586 6.05468 0 6.02543V14.0831C0 15.007 0.749707 15.7402 1.65702 15.7402H16.3429C17.2668 15.7402 18 14.9904 18 14.0831V6.02539C17.9608 6.05471 17.9209 6.08322 17.8799 6.11054L10.5043 11.0278Z" fill="white" />
                                                        <path d="M0.704883 5.2337L8.08077 10.1511C8.35998 10.3373 8.67997 10.4304 8.99996 10.4304C9.31999 10.4304 9.64002 10.3373 9.91923 10.1511L17.2951 5.2337C17.7365 4.93962 18 4.44743 18 3.91622C18 3.00283 17.2569 2.25977 16.3435 2.25977H1.65646C0.743098 2.2598 0 3.00286 0 3.9171C0 4.44743 0.263531 4.93962 0.704883 5.2337Z" fill="white" />
                                                    </svg>
                                                </span>
                                                Email
                                            </a>

                                            <button type='button' onClick={handleCopyLink}>
                                                <span className='iconbox'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <g clipPath="url(#clip0_766_171803)">
                                                            <path d="M10.9813 7.01495C10.7681 6.80047 10.5317 6.61034 10.2765 6.44806C9.60047 6.01518 8.81459 5.78516 8.01187 5.78516C6.89772 5.78309 5.82885 6.22577 5.0424 7.01495L1.22709 10.8333C0.441976 11.6199 0.000703868 12.6857 8.69407e-07 13.797C-0.00147543 16.1162 1.87736 17.9975 4.19655 17.999C5.30898 18.0028 6.37687 17.5623 7.16303 16.7752L10.3125 13.6257C10.3697 13.569 10.4016 13.4916 10.4012 13.411C10.4002 13.2454 10.2652 13.1119 10.0995 13.1128H9.97953C9.32152 13.1152 8.66938 12.9888 8.05988 12.7409C7.94758 12.6947 7.81851 12.7208 7.73295 12.8069L5.46835 15.0745C4.76514 15.7777 3.62501 15.7777 2.9218 15.0745C2.21859 14.3713 2.21859 13.2312 2.9218 12.5279L6.75213 8.70064C7.45478 7.99887 8.59304 7.99887 9.29568 8.70064C9.76922 9.14631 10.5079 9.14631 10.9814 8.70064C11.1851 8.49674 11.3086 8.22629 11.3293 7.93876C11.3512 7.59517 11.2245 7.25868 10.9813 7.01495Z" fill="white" />
                                                            <path d="M16.7678 1.22999C15.1279 -0.409998 12.4689 -0.409998 10.8289 1.22999L7.68247 4.37342C7.59607 4.46024 7.57115 4.59082 7.61948 4.70337C7.66725 4.81624 7.77889 4.88868 7.90142 4.88632H8.01239C8.66962 4.88513 9.3207 5.01248 9.92904 5.26127C10.0413 5.30749 10.1704 5.28141 10.256 5.19529L12.5146 2.93969C13.2178 2.23648 14.3579 2.23648 15.0611 2.93969C15.7643 3.64289 15.7643 4.78302 15.0611 5.48623L12.2476 8.29671L12.2236 8.32371L11.2398 9.30154C10.5371 10.0033 9.39888 10.0033 8.69623 9.30154C8.22269 8.85588 7.48405 8.85588 7.01055 9.30154C6.80552 9.50699 6.68189 9.77979 6.6626 10.0694C6.64066 10.413 6.76738 10.7495 7.01055 10.9932C7.35772 11.3419 7.76391 11.6262 8.21032 11.8331C8.27331 11.8631 8.3363 11.8871 8.39928 11.9141C8.46227 11.9411 8.52825 11.962 8.59124 11.986C8.65423 12.0101 8.7202 12.031 8.78319 12.049L8.96017 12.097C9.08014 12.127 9.20014 12.151 9.32309 12.172C9.47122 12.194 9.62039 12.208 9.77003 12.214H9.97998H9.99797L10.1779 12.193C10.2439 12.19 10.3129 12.175 10.3909 12.175H10.4929L10.6998 12.145L10.7958 12.127L10.9698 12.091H11.0028C11.7396 11.906 12.4124 11.5245 12.9494 10.9872L16.7677 7.16893C18.4078 5.52893 18.4078 2.86998 16.7678 1.22999Z" fill="white" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_766_171803">
                                                                <rect width="18" height="18" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </span>
                                                {copied ? 'Copied!' : 'Copy Link'}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className='butttton'>
                                    <button className='gotitbtn closebtnn' onClick={closeModal}>Close</button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default Banner
